// When the user scrolls the page, execute myFunction
window.onscroll = function() {
	myFunction();
};

// Get the navbar
var navbar = document.getElementById( 'site-nav' );
var headerImage = document.getElementById( 'header-image' );
var sidebarToggle = document.getElementById( 'sidebar-toggle' );
var siteTopHeight = document.querySelector('.site-top');

// Get the offset position of the navbar
var move = navbar.scrollHeight;
var animate = navbar.scrollHeight + 150;
var siteTopHeight = siteTopHeight.clientHeight;

// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
   if ( window.pageYOffset > move ) {
      navbar.classList.remove( 'logo-center' );
      navbar.classList.add( 'sticky-menu', 'logo-left' );
      sidebarToggle.classList.add( 'sticky-toggle' );
   } else {
      navbar.classList.remove( 'sticky-menu', 'logo-left' );
      navbar.classList.add( 'logo-center' );
      sidebarToggle.classList.remove( 'sticky-toggle' );
   }
   if ( window.pageYOffset > animate ) {
      navbar.classList.add( 'animate-in' );
      navbar.classList.remove( 'animate-out' );
      sidebarToggle.classList.add( 'animate-in' );
      sidebarToggle.classList.remove( 'animate-out' );
      sidebarToggle.style.height = '72' + 'px';
   } else if ( window.pageYOffset < animate && navbar.classList.contains('sticky-menu') && navbar.classList.contains('animate-in') ) {
      navbar.classList.add( 'animate-out' );
      navbar.classList.remove( 'animate-in' );
      sidebarToggle.classList.add( 'animate-out' );
      sidebarToggle.classList.remove( 'animate-in' );
      sidebarToggle.style.height = siteTopHeight + 'px';
   }
}
